import { apiClient } from '../lib/api-client';
import type { CommissionRateHistoryItemDto, SetCommissionRateDto } from '../types/admin-api';

// SW-98: staff-only commission rate management for a business — the only
// place a rate value or signed contract can ever be written.
export const commissionService = {
  getHistory: async (businessId: string) => {
    const response = await apiClient.get<CommissionRateHistoryItemDto[]>(
      `/businesses/${businessId}/commission`
    );
    return response.data;
  },

  setRate: async (businessId: string, data: SetCommissionRateDto) => {
    const response = await apiClient.post<CommissionRateHistoryItemDto>(
      `/businesses/${businessId}/commission/rate`,
      data
    );
    return response.data;
  },

  uploadContract: async (businessId: string, signedContract: File, tPayOffer?: File) => {
    const formData = new FormData();
    formData.append('SignedContract', signedContract);
    if (tPayOffer) {
      formData.append('TPayOffer', tPayOffer);
    }
    const response = await apiClient.post<CommissionRateHistoryItemDto>(
      `/businesses/${businessId}/commission/contract`,
      formData
    );
    return response.data;
  },
};
